import {CalculatorCondition} from "./CalculatorCondition";

export enum CalculatorName {
    SAVINGS = 'SAVINGS',
    RATE_CALCULATOR = 'RATE_CALCULATOR',
    EQUITY_CASH_OUT = 'EQUITY_CASH_OUT',
    EQUITY_RATE_AND_TERM_REFINANCE = 'EQUITY_RATE_AND_TERM_REFINANCE',
    TRIGGER_LEADS = 'TRIGGER_LEADS'
}

export const ALL_CALCULATORS: any = Object.keys(CalculatorName)
    .map(k => CalculatorName[k as any]);

export class Calculator {

    id: number;

    title: string;

    name: CalculatorName;

    enabled: boolean;

    description: string;

    conditions: CalculatorCondition[];

    public getNotificationImageUrl = () => {
        return Calculator.getImageUrl(name);
    };

    public static getImageUrl(name: CalculatorName) {
        switch (name) {
            case CalculatorName.SAVINGS:
                return '/app/images/calculations/opportunity_Payment_Savings.jpg';
            case CalculatorName.RATE_CALCULATOR:
                return '/app/images/calculations/opportunity_Rate_Reduction.jpg';
            case CalculatorName.EQUITY_CASH_OUT:
                return '/app/images/calculations/opportunity_Cash_Out.jpg';
            case CalculatorName.EQUITY_RATE_AND_TERM_REFINANCE:
                return '/app/images/calculations/opportunity_Equity_Growth.jpg';
            case CalculatorName.TRIGGER_LEADS:
                return '/app/images/calculations/opportunity_Trigger_Lead.jpg';
        }
    }
}